
// SVG Icon: right2
export default { id: "terriajs-right2" };
export const id = "terriajs-right2";
export const name = "right2";
